import { Dispatch } from 'redux';
import { config } from '../config';
import { RootApplicationAction, UiActions, ExpiringTokensWebSocketActions } from '../state/actions';
import { WebSocketStatuses } from '../types/WebSocket';
import { ExpiredTokenCode } from '@tradingblock/types';

class ExpiringTokensWebSocketService {
  private static instance: ExpiringTokensWebSocketService;
  private ws: WebSocket | null = null;
  private constructor() {}

  // Singleton instance access
  public static getInstance(): ExpiringTokensWebSocketService {
    if (!ExpiringTokensWebSocketService.instance) {
      ExpiringTokensWebSocketService.instance = new ExpiringTokensWebSocketService();
    }
    return ExpiringTokensWebSocketService.instance;
  }

  // Initialize WebSocket connection
  public async connect(dispatch: Dispatch<RootApplicationAction>, apiToken: string) {
    try {
      if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
        this.ws = new WebSocket(config.expiringTokensWebSocketUrl + '?token=' + apiToken);

        this.ws.onopen = () => {
          dispatch(ExpiringTokensWebSocketActions.setStatus(WebSocketStatuses.OPEN));
          this.sendMessage(JSON.stringify({ type: 'Subscribe' }));
        };

        this.ws.onmessage = (ev: MessageEvent) => {
          const jsonVal = ev.data;
          const valObj: { token: string; reason: string } = JSON.parse(jsonVal);
          console.warn('expired token message', jsonVal, valObj);
          if (valObj.token === apiToken) {
            let code: ExpiredTokenCode;
            switch (valObj.reason) {
              case 'DuplicateLogins':
                code = ExpiredTokenCode.DuplicateLogin;
                break;
              case 'ExpiredToken':
                code = ExpiredTokenCode.Expired;
                break;
              default:
                code = ExpiredTokenCode.Unknown;
            }
            dispatch(UiActions.setIsAuthSessionExpired(true));
          }
        };

        this.ws.onclose = (event: CloseEvent) => {
          if (event.reason) {
            console.warn(event.reason);
          }

          dispatch(ExpiringTokensWebSocketActions.setStatus(WebSocketStatuses.CLOSED));
        };

        this.ws.onerror = error => {
          dispatch(ExpiringTokensWebSocketActions.setStatus(WebSocketStatuses.ERROR));

          console.error('WebSocket error: ', error);
        };
      }
    } catch (error) {
      dispatch(ExpiringTokensWebSocketActions.setStatus(WebSocketStatuses.ERROR));

      console.error('WebSocket creation error: ', error);
    }
  }

  public sendMessage(data: string | ArrayBufferLike | Blob | ArrayBufferView) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(data);
    } else if (this.ws) {
      console.warn('trying to send message to closed/closing websocket', data);
    }
  }

  public shouldTryReconnect() {
    if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
      return true;
    }

    return false;
  }

  // Close WebSocket connection
  public closeConnection() {
    if (this.ws) {
      this.ws.close();
    }
  }
}

export const expiringTokensWebSocketService = ExpiringTokensWebSocketService.getInstance();
